import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OfferEndingText from './OfferEndingText.jsx';
import { futureDate } from './helpers.js';

class AddedValueMessagesTab extends Component {
  createMarkup(markupValue) {
    return { __html: markupValue };
  }

  render() {
    return (
      <ul className={'simple product-offers'}>
        {
          this.props.data.messages.map((avm, i) => (
            <li id={`product-deal-offer-${i}`} key={i}>
              <span className={'offer'}>
                {avm.title}
              </span>

              {new Date(avm.to) < futureDate() &&
                <OfferEndingText from={avm.from} to={avm.to} />}
              
              {avm.text &&
                <div dangerouslySetInnerHTML={this.createMarkup(avm.text)} />}
            </li>
          ))
        }
      </ul>
    );
  }
}

AddedValueMessagesTab.propTypes = {
  data: PropTypes.shape({
    messages: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        text: PropTypes.node
      })
    )
  }).isRequired
};

AddedValueMessagesTab.displayName = 'AddedValueMessagesTab';

export default AddedValueMessagesTab;
